<template>
  <div class="about-us">
    <!-- 头部导航 -->
    <Header />

    <!-- 主要内容 -->
    <main class="main-content">
      <!-- 顶部大图 -->
      <section class="banner-section">
        <img src="@/assets/images/wenjpg.png" alt="服务范围" class="banner-image">
      </section>


      <!-- 回馈社会模块51 -->
      <section class="social-contribution-section">
        <h2 class="section-title">{{ $t("hknews.hknews01") }}</h2>
        <div class="container">
          <div>
            <div class="contribution-content">
              <div style="display: flex;flex-direction: row; gap: 4rem;">
                <!-- 左侧四张图片 -->
                <div class="images-grid-container">
                  <div class="images-grid">
                    <div class="grid-image-item">
                      <img src="@/assets/images/news/huikui/anli01.png" alt="四川外国语大学德语专业庆典活动" class="grid-img">

                    </div>
                    <div class="grid-image-item">
                      <img src="@/assets/images/news/huikui/anli02.png" alt="启文奖学金捐赠证书" class="grid-img">

                    </div>
                    <div class="grid-image-item">
                      <img src="@/assets/images/news/huikui/anli03.png" alt="与学校领导合影" class="grid-img">

                    </div>
                    <div class="grid-image-item">
                      <img src="@/assets/images/news/huikui/anli04.png" alt="奖学金颁发仪式" class="grid-img">

                    </div>
                  </div>
                  <div class="grid-decoration">
                    <div class="decoration-circle"></div>
                    <div class="decoration-line"></div>
                  </div>
                </div>

                <!-- 右侧文字内容 -->
                <div class="contribution-text-container">
                  <div class="contribution-text-content">
                    <div class="text-header">
                      <h3 class="contribution-subtitle">{{ $t("hknews.hknews02") }}<br>{{ $t("hknews.hknews03") }}</h3>
                      <div class="subtitle-decoration"></div>
                    </div>

                    <p class="contribution-description" v-show="$t('hknews.hknews04')">
                      {{ $t("hknews.hknews04") }}<strong>{{ $t("hknews.hknews05") }}</strong>{{ $t("hknews.hknews06") }}
                    </p>


                  </div>
                </div>

              </div>
              <p class="contribution-description" v-show="$t('hknews.hknews0411')">
                {{ $t("hknews.hknews0411") }}
              </p>
            </div>

          </div>

          <div class="contribution-text-content">




          </div>
        </div>
      </section>
      <!-- 点亮智慧扶贫助学工程模块 52 -->
      <section class="wisdom-project-section">
        <h2 class="section-title">{{ $t("hknews.hknews07") }}</h2>
        <div class="container">

          <div class="wisdom-content"  style="flex-direction: column;display: flex;">
            <div style="display: flex;flex-direction: row; gap: 4rem;">
              <!-- 左侧两张图片 -->
              <div class="wisdom-images-container">
                <div class="wisdom-images-grid">
                  <div class="wisdom-image-item">
                    <img src="@/assets/images/news/huikui/anli05.png" alt="首都知识产权服务业协会感谢信" class="wisdom-img">
                  </div>
                  <div class="wisdom-image-item">
                    <img src="@/assets/images/news/huikui/anli06.png" alt="点亮智慧扶贫助学工程详情" class="wisdom-img">
                  </div>
                </div>
                <div class="wisdom-decoration">
                  <div class="wisdom-decoration-circle"></div>
                  <div class="wisdom-decoration-line"></div>
                </div>
              </div>

              <!-- 右侧文字内容 -->
              <div class="wisdom-text-container">
                <div class="wisdom-text-content">
                  <div class="wisdom-text-header">
                    <h3 class="wisdom-subtitle">{{ $t("hknews.hknews08") }}<br>{{ $t("hknews.hknews081") }}</h3>
                    <div class="wisdom-subtitle-decoration"></div>
                  </div>

                  <p class="wisdom-description" v-show="$t('hknews.hknews09')">
                    {{ $t("hknews.hknews09") }}<strong>{{ $t("hknews.hknews10") }}</strong>{{ $t("hknews.hknews11") }}
                  </p>



                </div>
              </div>
            </div>
            <div class="wisdom-text-content">
          

              <p class="wisdom-description" v-show="$t('hknews.hknews09111')">
                {{ $t("hknews.hknews09111") }} 
              </p>



            </div>

          </div>

        </div>
      </section>


      <!-- 回馈社会模块53 -->
      <section class="education-mentor-section">
        <div class="container">
          <div class="education-mentor-layout" style="display: flex;flex-direction: row;gap:6rem">
            <!-- 左侧区域 (65%宽度) -->
            <div class="left-section">
              <h3 class="section-subtitle">{{ $t("hknews.hknews12") }}</h3>
              <div class="image-container">
                <img src="@/assets/images/news/huikui/anli07.png" style="height:27rem;  object-fit: contain;"
                  class="section-img">

              </div>
            </div>

            <!-- 右侧区域 (35%宽度) -->
            <div class="right-section">
              <h3 class="section-subtitle">{{ $t("hknews.hknews13") }}</h3>
              <div class="image-container">
                <img src="@/assets/images/news/huikui/anli08.png" style="height:27rem;  object-fit: contain;"
                  class="section-img">

              </div>
            </div>
          </div>
        </div>
      </section>


    </main>

    <!-- 页脚 -->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'AboutUs',
  components: {
    Header,
    Footer
  },
  data() {
    return {

    }
  }
}
</script>

<style scoped>
.about-us {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  color: #333;
}

.main-content {
  min-height: 80vh;
}

/* 页面标题部分 */
.page-header {
  background-color: #FFF5F0;
  padding: 2rem 0;
  border-bottom: 1px solid #e9ecef;
}

.page-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0;
  text-align: center;
  color: #FF631E;
}

/* 新闻列表部分 */
.news-section {
  background-color: #FFF5F0;
  padding: 3rem 0;
}

.news-header {
  margin-bottom: 2rem;
}

.news-header .section-title {
  color: #FF631E;
  font-size: 1.8rem;
  font-weight: 600;
  text-align: center;
}

.news-content {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 2rem;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.news-item {
  padding: 0.8rem 0;
  border-bottom: 1px solid #eee;
}

.news-item:last-child {
  border-bottom: none;
}

.news-link {
  color: #333;
  text-decoration: none;
  font-size: 1rem;
  line-height: 1.5;
  transition: color 0.3s ease;
  display: block;
}

.news-link:hover {
  color: #FF631E;
}

/* 通用样式 */
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 4rem 0;
}

.section-title {
  font-size: 2.2rem;
  font-weight: 600;
  margin-bottom: 2rem;
  color: #333;
}

/* 关于我们内容样式 */
.about-content {
  padding: 4rem 0;
}

.about-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 3rem;
  align-items: center;
}

.about-image {
  flex: 1;
  min-width: 300px;
}

.about-img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.about-text {
  flex: 1;
  min-width: 300px;
}

.about-paragraph {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
  color: #666;
}

/* 价值观部分样式 */
.values-section {
  background-color: #f8f9fa;
  padding: 4rem 0;
}

.values-section .section-title {
  text-align: center;
  margin-bottom: 3rem;
}

.values-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.value-card {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.value-card:hover {
  transform: translateY(-5px);
}

.value-icon {
  font-size: 2.5rem;
  color: #007bff;
  margin-bottom: 1.5rem;
}

.value-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #333;
}

.value-text {
  font-size: 1rem;
  line-height: 1.6;
  color: #666;
}

/* 顶部大图部分 */
.banner-section {
  width: 100%;
  height: 500px;
  overflow: hidden;
  position: relative;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 回馈社会模块样式 */
.social-contribution-section {
  background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);
  padding: 4rem 0;
  position: relative;
}

.social-contribution-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, #FF631E, transparent);
}

.social-contribution-section .section-title {
  text-align: center;
  color: #FF631E;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 3rem;
  position: relative;
  text-shadow: 0 2px 4px rgba(255, 99, 30, 0.1);
}

.social-contribution-section .section-title::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 4px;
  background: linear-gradient(90deg, #FF631E, #ff8c42);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(255, 99, 30, 0.3);
}

/* 回馈社会内容容器 */
.contribution-content {
  display: flex;
  align-items: flex-start;
  gap: 4rem;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.95);
  padding: 3rem 3rem 0rem 3rem;
  border-radius: 20px;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 99, 30, 0.1);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.contribution-content:hover {
  transform: translateY(-8px);
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.12);
  border-color: rgba(255, 99, 30, 0.2);
}

/* 左侧图片网格容器 */
.images-grid-container {
  flex: 0 0 500px;
  position: relative;
}

.images-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  position: relative;
  z-index: 2;
}

.grid-image-item {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  width: 325px;
  aspect-ratio: 4/3;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 2px solid rgba(255, 99, 30, 0.2);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.grid-image-item:hover {
  transform: scale(1.05);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 99, 30, 0.4);
  z-index: 10;
}

.grid-img {
  width: 325px;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.grid-image-item:hover .grid-img {
  transform: scale(1.1);
}

.image-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  color: white;
  padding: 1rem;
  transform: translateY(100%);
  transition: transform 0.3s ease;
}

.grid-image-item:hover .image-overlay {
  transform: translateY(0);
}

.overlay-text {
  font-size: 0.9rem;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

/* 网格装饰 */
.grid-decoration {
  position: absolute;
  top: -20px;
  right: -20px;
  z-index: 1;
}

.decoration-circle {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #FF631E, #ff8c42);
  border-radius: 50%;
  opacity: 0.8;
  position: relative;
}

.decoration-circle::before {
  content: '🏆';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 2rem;
}

.decoration-line {
  position: absolute;
  top: 40px;
  left: -30px;
  width: 60px;
  height: 2px;
  background: linear-gradient(90deg, #FF631E, #ff8c42);
  border-radius: 1px;
}

/* 右侧文字容器 */
.contribution-text-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.contribution-text-content {
  width: 100%;
}

.text-header {
  margin-bottom: 2rem;
}

.contribution-subtitle {
  font-size: 1.8rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 1rem 0;
  line-height: 1.3;
  background: linear-gradient(120deg, #FF631E, #ff8c42);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.subtitle-decoration {
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #FF631E, #ff8c42);
  border-radius: 2px;
  margin-bottom: 1rem;
}

.contribution-description {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #2c3e50;
  margin: 0 0 2.5rem 0;
  text-align: justify;
  padding: 2rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 16px;
  border: 2px solid rgba(255, 99, 30, 0.1);
  box-shadow: 0 8px 32px rgba(255, 99, 30, 0.05);
  position: relative;
  transition: all 0.3s ease;
}

.contribution-description:hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 48px rgba(255, 99, 30, 0.1);
  border-color: rgba(255, 99, 30, 0.2);
}

.contribution-description::before {
  content: '"';
  position: absolute;
  top: -10px;
  left: 20px;
  font-size: 3rem;
  color: #FF631E;
  font-family: serif;
  opacity: 0.3;
}

.contribution-description strong {
  color: #FF631E;
  font-weight: 700;
  background: linear-gradient(120deg, #FF631E, #ff8c42);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
}

.contribution-description strong::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #FF631E, #ff8c42);
  border-radius: 1px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.contribution-description:hover strong::after {
  opacity: 0.6;
}

/* 亮点卡片 */
.contribution-highlights {
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.highlight-card {
  flex: 1;
  min-width: 150px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 1.5rem;
  border-radius: 16px;
  border: 2px solid rgba(255, 99, 30, 0.1);
  box-shadow: 0 8px 32px rgba(255, 99, 30, 0.05);
  transition: all 0.3s ease;
  text-align: center;
}

.highlight-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 16px 48px rgba(255, 99, 30, 0.15);
  border-color: rgba(255, 99, 30, 0.3);
}

.highlight-icon {
  font-size: 2rem;
  margin-bottom: 0.8rem;
  display: block;
}

.highlight-content h4 {
  font-size: 1.1rem;
  font-weight: 700;
  color: #FF631E;
  margin: 0 0 0.5rem 0;
}

.highlight-content p {
  font-size: 0.9rem;
  color: #666;
  margin: 0;
  line-height: 1.4;
}

/* 点亮智慧助学工程模块样式 */
.wisdom-project-section {
  background: linear-gradient(135deg, #fff5f0 0%, #ffffff 100%);
  padding: 4rem 0;
  position: relative;
}

.wisdom-project-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, #FF631E, transparent);
}

.wisdom-project-section .section-title {
  text-align: center;
  color: #FF631E;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 3rem;
  position: relative;
  text-shadow: 0 2px 4px rgba(255, 99, 30, 0.1);
}

.wisdom-project-section .section-title::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 4px;
  background: linear-gradient(90deg, #FF631E, #ff8c42);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(255, 99, 30, 0.3);
}

/* 智慧工程内容容器 */
.wisdom-content {
  display: flex;
  align-items: flex-start;
  gap: 4rem;
  background: rgba(255, 255, 255, 0.95);
  padding: 3rem;
  border-radius: 20px;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 99, 30, 0.1);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.wisdom-content:hover {
  transform: translateY(-8px);
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.12);
  border-color: rgba(255, 99, 30, 0.2);
}

/* 左侧图片容器 */
.wisdom-images-container {
  flex: 0 0 600px;
  position: relative;
}

.wisdom-images-grid {
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  position: relative;
  z-index: 2;
}

.wisdom-image-item {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 3px solid rgba(255, 99, 30, 0.2);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.wisdom-image-item:hover {
  transform: scale(1.05);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 99, 30, 0.4);
  z-index: 10;
}

.wisdom-img {
  width: 100%;
  height: 23rem;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.wisdom-image-item:hover .wisdom-img {
  transform: scale(1.1);
}

.wisdom-image-item .image-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  color: white;
  padding: 1.2rem;
  transform: translateY(100%);
  transition: transform 0.3s ease;
}

.wisdom-image-item:hover .image-overlay {
  transform: translateY(0);
}

.wisdom-image-item .overlay-text {
  font-size: 1rem;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

/* 智慧工程装饰 */
.wisdom-decoration {
  position: absolute;
  top: -25px;
  right: -25px;
  z-index: 1;
}

.wisdom-decoration-circle {
  width: 90px;
  height: 90px;
  background: linear-gradient(135deg, #FF631E, #ff8c42);
  border-radius: 50%;
  opacity: 0.9;
  position: relative;
  box-shadow: 0 8px 32px rgba(255, 99, 30, 0.3);
}

.wisdom-decoration-circle::before {
  content: '💡';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 2.2rem;
}

.wisdom-decoration-line {
  position: absolute;
  top: 45px;
  left: -40px;
  width: 80px;
  height: 3px;
  background: linear-gradient(90deg, #FF631E, #ff8c42);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(255, 99, 30, 0.3);
}

/* 右侧文字容器 */
.wisdom-text-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.wisdom-text-content {
  width: 100%;
}

.wisdom-text-header {
  margin-bottom: 2rem;
}

.wisdom-subtitle {
  font-size: 1.8rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 1rem 0;
  line-height: 1.3;
  background: linear-gradient(120deg, #FF631E, #ff8c42);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.wisdom-subtitle-decoration {
  width: 80px;
  height: 3px;
  background: linear-gradient(90deg, #FF631E, #ff8c42);
  border-radius: 2px;
  margin-bottom: 1rem;
}

.wisdom-description {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #2c3e50;
  margin: 0 0 2.5rem 0;
  text-align: justify;
  padding: 2rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 16px;
  border: 2px solid rgba(255, 99, 30, 0.1);
  box-shadow: 0 8px 32px rgba(255, 99, 30, 0.05);
  position: relative;
  transition: all 0.3s ease;
}

.wisdom-description:hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 48px rgba(255, 99, 30, 0.1);
  border-color: rgba(255, 99, 30, 0.2);
}

.wisdom-description::before {
  content: '"';
  position: absolute;
  top: -10px;
  left: 20px;
  font-size: 3rem;
  color: #FF631E;
  font-family: serif;
  opacity: 0.3;
}

.wisdom-description strong {
  color: #FF631E;
  font-weight: 700;
  background: linear-gradient(120deg, #FF631E, #ff8c42);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;
}

.wisdom-description strong::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #FF631E, #ff8c42);
  border-radius: 1px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.wisdom-description:hover strong::after {
  opacity: 0.6;
}

/* 特色功能展示 */
.wisdom-features {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 2.5rem;
  flex-wrap: wrap;
}

.feature-item {
  flex: 1;
  min-width: 150px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 1.5rem;
  border-radius: 16px;
  border: 2px solid rgba(255, 99, 30, 0.1);
  box-shadow: 0 8px 32px rgba(255, 99, 30, 0.05);
  transition: all 0.3s ease;
  text-align: center;
}

.feature-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 16px 48px rgba(255, 99, 30, 0.15);
  border-color: rgba(255, 99, 30, 0.3);
}

.feature-icon {
  font-size: 2rem;
  margin-bottom: 0.8rem;
  display: block;
}

.feature-content h4 {
  font-size: 1.1rem;
  font-weight: 700;
  color: #FF631E;
  margin: 0 0 0.5rem 0;
}

.feature-content p {
  font-size: 0.9rem;
  color: #666;
  margin: 0;
  line-height: 1.4;
}

/* 时间线展示 */
.wisdom-timeline {
  display: flex;
  gap: 2rem;
  align-items: center;
}

.timeline-item {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 16px;
  border: 2px solid rgba(255, 99, 30, 0.1);
  box-shadow: 0 8px 32px rgba(255, 99, 30, 0.05);
  transition: all 0.3s ease;
}

.timeline-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 48px rgba(255, 99, 30, 0.15);
  border-color: rgba(255, 99, 30, 0.3);
}

.timeline-year {
  flex: 0 0 60px;
  font-size: 1.2rem;
  font-weight: 700;
  color: #FF631E;
  text-align: center;
  background: linear-gradient(135deg, #FF631E, #ff8c42);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.timeline-content h5 {
  font-size: 1rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 0.3rem 0;
}

.timeline-content p {
  font-size: 0.9rem;
  color: #666;
  margin: 0;
  line-height: 1.4;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .container {
    width: 90%;
  }

  .banner-section {
    height: 600px;
  }
}

@media (max-width: 992px) {
  .values-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .banner-section {
    height: 500px;
  }

  .news-content {
    padding: 1.5rem;
  }

  .news-link {
    font-size: 0.95rem;
  }

  /* 回馈社会模块响应式 */
  .social-contribution-section {
    padding: 3rem 0;
  }

  .social-contribution-section .section-title {
    font-size: 2.2rem;
    margin-bottom: 2.5rem;
  }

  .contribution-content {
    gap: 3rem;
    padding: 2rem;
  }

  .images-grid-container {
    flex: 0 0 450px;
  }

  .images-grid {
    gap: 0.8rem;
  }

  .grid-decoration {
    top: -15px;
    right: -15px;
  }

  .decoration-circle {
    width: 70px;
    height: 70px;
  }

  .decoration-circle::before {
    font-size: 1.8rem;
  }

  .decoration-line {
    width: 50px;
    left: -25px;
    top: 35px;
  }

  .contribution-subtitle {
    font-size: 1.6rem;
  }

  .contribution-description {
    font-size: 1rem;
    padding: 1.5rem;
  }

  .contribution-highlights {
    gap: 1rem;
  }

  .highlight-card {
    padding: 1.2rem;
  }

  .highlight-content h4 {
    font-size: 1rem;
  }

  .highlight-content p {
    font-size: 0.85rem;
  }

  /* 点亮智慧工程模块响应式 */
  .wisdom-project-section {
    padding: 3rem 0;
  }

  .wisdom-project-section .section-title {
    font-size: 2.2rem;
    margin-bottom: 2.5rem;
  }

  .wisdom-content {
    gap: 3rem;
    padding: 2rem;
  }

  .wisdom-images-container {
    flex: 0 0 350px;
  }

  .wisdom-images-grid {
    gap: 1.2rem;
  }

  .wisdom-decoration {
    top: -20px;
    right: -20px;
  }

  .wisdom-decoration-circle {
    width: 80px;
    height: 80px;
  }

  .wisdom-decoration-circle::before {
    font-size: 2rem;
  }

  .wisdom-decoration-line {
    width: 70px;
    left: -35px;
    top: 40px;
  }

  .wisdom-subtitle {
    font-size: 1.6rem;
  }

  .wisdom-subtitle-decoration {
    width: 60px;
  }

  .wisdom-description {
    font-size: 1rem;
    padding: 1.5rem;
  }

  .wisdom-features {
    gap: 1rem;
  }

  .feature-item {
    padding: 1.2rem;
  }

  .feature-content h4 {
    font-size: 1rem;
  }

  .feature-content p {
    font-size: 0.85rem;
  }

  .wisdom-timeline {
    gap: 1.5rem;
  }

  .timeline-item {
    padding: 1.2rem;
  }

  .timeline-year {
    flex: 0 0 50px;
    font-size: 1.1rem;
  }

  .timeline-content h5 {
    font-size: 0.95rem;
  }

  .timeline-content p {
    font-size: 0.85rem;
  }
}

@media (max-width: 768px) {
  .about-wrapper {
    flex-direction: column;
  }

  .values-grid {
    grid-template-columns: 1fr;
  }

  .page-title {
    font-size: 2rem;
  }

  .section-title {
    font-size: 1.8rem;
  }

  .banner-section {
    height: 400px;
  }

  .news-section {
    padding: 2rem 0;
  }

  .news-header {
    margin-bottom: 1.5rem;
  }

  .container {
    padding: 2rem 0;
  }

  /* 回馈社会模块平板响应式 */
  .social-contribution-section {
    padding: 2.5rem 0;
  }

  .social-contribution-section .section-title {
    font-size: 2rem;
    margin-bottom: 2rem;
  }

  .contribution-content {
    flex-direction: column;
    gap: 2.5rem;
    padding: 1.5rem;
    text-align: center;
  }

  .images-grid-container {
    flex: none;
    max-width: 500px;
    align-self: center;
  }

  .images-grid {
    gap: 0.8rem;
  }

  .grid-decoration {
    top: -12px;
    right: -12px;
  }

  .decoration-circle {
    width: 60px;
    height: 60px;
  }

  .decoration-circle::before {
    font-size: 1.5rem;
  }

  .decoration-line {
    width: 40px;
    left: -20px;
    top: 30px;
  }

  .contribution-text-container {
    width: 100%;
  }

  .text-header {
    text-align: center;
    margin-bottom: 1.5rem;
  }

  .contribution-subtitle {
    font-size: 1.5rem;
  }

  .subtitle-decoration {
    margin: 0 auto 1rem auto;
  }

  .contribution-description {
    font-size: 0.95rem;
    line-height: 1.7;
    padding: 1.2rem;
    text-align: left;
  }

  .contribution-description::before {
    font-size: 2.5rem;
    top: -8px;
    left: 15px;
  }

  .contribution-highlights {
    justify-content: center;
    gap: 1rem;
  }

  .highlight-card {
    flex: 0 1 calc(50% - 0.5rem);
    min-width: 140px;
    padding: 1rem;
  }

  .highlight-icon {
    font-size: 1.8rem;
  }

  .highlight-content h4 {
    font-size: 0.95rem;
  }

  .highlight-content p {
    font-size: 0.8rem;
  }

  /* 点亮智慧工程模块平板响应式 */
  .wisdom-project-section {
    padding: 2.5rem 0;
  }

  .wisdom-project-section .section-title {
    font-size: 2rem;
    margin-bottom: 2rem;
  }

  .wisdom-content {
    flex-direction: column;
    gap: 2.5rem;
    padding: 1.5rem;
    text-align: center;
  }

  .wisdom-images-container {
    flex: none;
    max-width: 400px;
    align-self: center;
  }

  .wisdom-images-grid {
    gap: 1rem;
  }

  .wisdom-decoration {
    top: -15px;
    right: -15px;
  }

  .wisdom-decoration-circle {
    width: 70px;
    height: 70px;
  }

  .wisdom-decoration-circle::before {
    font-size: 1.8rem;
  }

  .wisdom-decoration-line {
    width: 60px;
    left: -30px;
    top: 35px;
  }

  .wisdom-text-container {
    width: 100%;
  }

  .wisdom-text-header {
    text-align: center;
    margin-bottom: 1.5rem;
  }

  .wisdom-subtitle {
    font-size: 1.5rem;
  }

  .wisdom-subtitle-decoration {
    margin: 0 auto 1rem auto;
    width: 50px;
  }

  .wisdom-description {
    font-size: 0.95rem;
    line-height: 1.7;
    padding: 1.2rem;
    text-align: left;
  }

  .wisdom-description::before {
    font-size: 2.5rem;
    top: -8px;
    left: 15px;
  }

  .wisdom-features {
    justify-content: center;
    gap: 1rem;
  }

  .feature-item {
    flex: 0 1 calc(50% - 0.5rem);
    min-width: 140px;
    padding: 1rem;
  }

  .feature-icon {
    font-size: 1.8rem;
  }

  .feature-content h4 {
    font-size: 0.95rem;
  }

  .feature-content p {
    font-size: 0.8rem;
  }

  .wisdom-timeline {
    flex-direction: column;
    gap: 1rem;
  }

  .timeline-item {
    padding: 1rem;
    max-width: 400px;
  }

  .timeline-year {
    flex: 0 0 45px;
    font-size: 1rem;
  }

  .timeline-content h5 {
    font-size: 0.9rem;
  }

  .timeline-content p {
    font-size: 0.8rem;
  }
}

@media (max-width: 576px) {
  .page-title {
    font-size: 1.8rem;
  }

  .section-title {
    font-size: 1.6rem;
  }

  .banner-section {
    height: 300px;
  }

  .news-item {
    padding: 0.6rem 0;
  }

  .news-link {
    font-size: 0.9rem;
    line-height: 1.4;
  }

  .news-content {
    padding: 1rem;
  }

  /* 回馈社会模块手机端响应式 */
  .social-contribution-section {
    padding: 2rem 0;
  }

  .social-contribution-section .section-title {
    font-size: 1.8rem;
    margin-bottom: 1.5rem;
  }

  .social-contribution-section .section-title::after {
    width: 60px;
    height: 3px;
  }

  .contribution-content {
    flex-direction: column;
    gap: 2rem;
    padding: 1rem;
    border-radius: 12px;
  }

  .contribution-content:hover {
    transform: translateY(-3px);
  }

  .images-grid-container {
    max-width: 100%;
  }

  .images-grid {
    gap: 0.6rem;
  }

  .grid-image-item {
    border-radius: 8px;
    border-width: 1px;
  }

  .grid-image-item:hover {
    transform: scale(1.02);
  }

  .grid-decoration {
    top: -8px;
    right: -8px;
  }

  .decoration-circle {
    width: 50px;
    height: 50px;
  }

  .decoration-circle::before {
    font-size: 1.2rem;
  }

  .decoration-line {
    width: 30px;
    left: -15px;
    top: 25px;
  }

  .contribution-subtitle {
    font-size: 1.3rem;
    line-height: 1.2;
  }

  .subtitle-decoration {
    width: 40px;
    height: 2px;
  }

  .contribution-description {
    font-size: 0.9rem;
    line-height: 1.6;
    padding: 1rem;
    border-radius: 8px;
    border-width: 1px;
  }

  .contribution-description::before {
    font-size: 2rem;
    top: -5px;
    left: 10px;
  }

  .contribution-highlights {
    flex-direction: column;
    align-items: center;
    gap: 0.8rem;
  }

  .highlight-card {
    flex: none;
    width: 100%;
    max-width: 280px;
    padding: 1rem;
    border-radius: 10px;
    border-width: 1px;
  }

  .highlight-icon {
    font-size: 1.5rem;
    margin-bottom: 0.6rem;
  }

  .highlight-content h4 {
    font-size: 0.9rem;
  }

  .highlight-content p {
    font-size: 0.8rem;
  }

  /* 点亮智慧工程模块手机端响应式 */
  .wisdom-project-section {
    padding: 2rem 0;
  }

  .wisdom-project-section .section-title {
    font-size: 1.8rem;
    margin-bottom: 1.5rem;
  }

  .wisdom-project-section .section-title::after {
    width: 80px;
    height: 3px;
  }

  .wisdom-content {
    flex-direction: column;
    gap: 2rem;
    padding: 1rem;
    border-radius: 12px;
  }

  .wisdom-content:hover {
    transform: translateY(-3px);
  }

  .wisdom-images-container {
    max-width: 100%;
  }

  .wisdom-images-grid {
    gap: 0.8rem;
  }

  .wisdom-image-item {
    border-radius: 8px;
    border-width: 2px;
  }

  .wisdom-image-item:hover {
    transform: scale(1.02);
  }

  .wisdom-decoration {
    top: -10px;
    right: -10px;
  }

  .wisdom-decoration-circle {
    width: 60px;
    height: 60px;
  }

  .wisdom-decoration-circle::before {
    font-size: 1.5rem;
  }

  .wisdom-decoration-line {
    width: 50px;
    left: -25px;
    top: 30px;
    height: 2px;
  }

  .wisdom-subtitle {
    font-size: 1.3rem;
    line-height: 1.2;
  }

  .wisdom-subtitle-decoration {
    width: 40px;
    height: 2px;
  }

  .wisdom-description {
    font-size: 0.9rem;
    line-height: 1.6;
    padding: 1rem;
    border-radius: 8px;
    border-width: 1px;
  }

  .wisdom-description::before {
    font-size: 2rem;
    top: -5px;
    left: 10px;
  }

  .wisdom-features {
    flex-direction: column;
    align-items: center;
    gap: 0.8rem;
  }

  .feature-item {
    flex: none;
    width: 100%;
    max-width: 280px;
    padding: 1rem;
    border-radius: 10px;
    border-width: 1px;
  }

  .feature-icon {
    font-size: 1.5rem;
    margin-bottom: 0.6rem;
  }

  .feature-content h4 {
    font-size: 0.9rem;
  }

  .feature-content p {
    font-size: 0.8rem;
  }

  .wisdom-timeline {
    flex-direction: column;
    gap: 0.8rem;
  }

  .timeline-item {
    flex-direction: column;
    text-align: center;
    padding: 1rem;
    border-radius: 10px;
    border-width: 1px;
    max-width: 100%;
  }

  .timeline-year {
    flex: none;
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    background: linear-gradient(135deg, #FF631E, #ff8c42);
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 20px;
    width: fit-content;
    align-self: center;
  }

  .timeline-content h5 {
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
  }

  .timeline-content p {
    font-size: 0.8rem;
    line-height: 1.4;
  }

  /* 教育评估与创业导师模块样式 */
  .education-mentor-section {
    background: linear-gradient(135deg, #f8f9fa 0%, #fff 100%);
    padding: 4rem 0;
    position: relative;
  }

  .education-mentor-section::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, #FF631E, transparent);
  }

  .education-mentor-section .section-title {
    text-align: center;
    color: #FF631E;
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 3rem;
    position: relative;
    text-shadow: 0 2px 4px rgba(255, 99, 30, 0.1);
  }

  .education-mentor-section .section-title::after {
    content: '';
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: 140px;
    height: 4px;
    background: linear-gradient(90deg, #FF631E, #ff8c42);
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(255, 99, 30, 0.3);
  }

  /* 教育导师内容容器 */
  .education-mentor-content {
    display: flex;
    gap: 3rem;
    margin-bottom: 3rem;
  }

  /* 卡片通用样式 */
  .education-card,
  .mentor-card {
    flex: 1;
    background: rgba(255, 255, 255, 0.95);
    padding: 2.5rem;
    border-radius: 20px;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.08);
    backdrop-filter: blur(15px);
    border: 1px solid rgba(255, 99, 30, 0.1);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
  }

  .education-card:hover,
  .mentor-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.12);
    border-color: rgba(255, 99, 30, 0.2);
  }

  /* 卡片头部 */
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
    position: relative;
  }

  .card-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #2c3e50;
    margin: 0;
    background: linear-gradient(120deg, #FF631E, #ff8c42);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .card-decoration {
    position: absolute;
    top: -10px;
    right: -10px;
    width: 50px;
    height: 50px;
    background: linear-gradient(135deg, #FF631E, #ff8c42);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 32px rgba(255, 99, 30, 0.3);
  }

  .decoration-icon {
    font-size: 1.5rem;
    color: white;
  }

  /* 卡片图片容器 */
  .card-image-container {
    position: relative;
    margin-bottom: 1.5rem;
    border-radius: 16px;
    overflow: hidden;
    aspect-ratio: 4/3;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    border: 3px solid rgba(255, 99, 30, 0.2);
    transition: all 0.4s ease;
  }

  .card-image-container:hover {
    transform: scale(1.02);
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.15);
    border-color: rgba(255, 99, 30, 0.4);
  }

  .card-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s ease;
  }

  .card-image-container:hover .card-img {
    transform: scale(1.1);
  }

  /* 图片遮罩 */
  .image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255, 99, 30, 0.9), rgba(255, 140, 66, 0.9));
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    padding: 1.5rem;
  }

  .card-image-container:hover .image-overlay {
    opacity: 1;
  }

  .overlay-content {
    text-align: center;
  }

  .overlay-content h4 {
    font-size: 1.3rem;
    font-weight: 700;
    margin: 0 0 0.8rem 0;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }

  .overlay-content p {
    font-size: 1rem;
    margin: 0 0 1rem 0;
    line-height: 1.4;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  }

  .certificate-details {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
  }

  .detail-item {
    font-size: 0.9rem;
    opacity: 0.9;
    background: rgba(255, 255, 255, 0.2);
    padding: 0.3rem 0.8rem;
    border-radius: 15px;
    backdrop-filter: blur(10px);
  }

  /* 卡片描述 */
  .card-description {
    font-size: 1rem;
    line-height: 1.6;
    color: #666;
    text-align: justify;
  }

  .card-description p {
    margin: 0;
  }

  /* 成就统计 */
  .achievements-stats {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
    background: rgba(255, 255, 255, 0.95);
    padding: 2rem;
    border-radius: 20px;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.08);
    backdrop-filter: blur(15px);
    border: 1px solid rgba(255, 99, 30, 0.1);
    transition: all 0.3s ease;
  }

  .achievements-stats:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12);
    border-color: rgba(255, 99, 30, 0.2);
  }

  .stat-item {
    text-align: center;
    flex: 1;
  }

  .stat-number {
    font-size: 2rem;
    font-weight: 700;
    background: linear-gradient(120deg, #FF631E, #ff8c42);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 0.5rem;
  }

  .stat-label {
    font-size: 0.9rem;
    color: #666;
    font-weight: 600;
  }

  .stat-divider {
    width: 1px;
    height: 40px;
    background: linear-gradient(180deg, transparent, #FF631E, transparent);
    opacity: 0.3;
  }

  /* 响应式设计 */
  @media (max-width: 992px) {
    .education-mentor-section {
      padding: 3rem 0;
    }

    .education-mentor-section .section-title {
      font-size: 2.2rem;
      margin-bottom: 2.5rem;
    }

    .education-mentor-content {
      gap: 2rem;
    }

    .education-card,
    .mentor-card {
      padding: 2rem;
    }

    .card-title {
      font-size: 1.3rem;
    }

    .card-decoration {
      width: 45px;
      height: 45px;
      top: -8px;
      right: -8px;
    }

    .decoration-icon {
      font-size: 1.3rem;
    }

    .overlay-content h4 {
      font-size: 1.2rem;
    }

    .overlay-content p {
      font-size: 0.9rem;
    }

    .achievements-stats {
      gap: 1.5rem;
      padding: 1.5rem;
    }

    .stat-number {
      font-size: 1.8rem;
    }
  }

  @media (max-width: 768px) {
    .education-mentor-section {
      padding: 2.5rem 0;
    }

    .education-mentor-section .section-title {
      font-size: 2rem;
      margin-bottom: 2rem;
    }

    .education-mentor-content {
      flex-direction: column;
      gap: 2rem;
    }

    .education-card,
    .mentor-card {
      padding: 1.5rem;
    }

    .card-title {
      font-size: 1.2rem;
      line-height: 1.3;
    }

    .card-decoration {
      width: 40px;
      height: 40px;
      top: -6px;
      right: -6px;
    }

    .decoration-icon {
      font-size: 1.2rem;
    }

    .card-image-container {
      border-radius: 12px;
      border-width: 2px;
    }

    .overlay-content {
      padding: 1rem;
    }

    .overlay-content h4 {
      font-size: 1.1rem;
    }

    .overlay-content p {
      font-size: 0.85rem;
    }

    .detail-item {
      font-size: 0.8rem;
      padding: 0.2rem 0.6rem;
    }

    .card-description {
      font-size: 0.9rem;
    }

    .achievements-stats {
      flex-wrap: wrap;
      gap: 1rem;
      padding: 1.2rem;
    }

    .stat-item {
      flex: 0 1 calc(50% - 0.5rem);
    }

    .stat-divider {
      display: none;
    }

    .stat-number {
      font-size: 1.5rem;
    }

    .stat-label {
      font-size: 0.8rem;
    }
  }

  @media (max-width: 576px) {
    .education-mentor-section {
      padding: 2rem 0;
    }

    .education-mentor-section .section-title {
      font-size: 1.8rem;
      margin-bottom: 1.5rem;
    }

    .education-mentor-section .section-title::after {
      width: 80px;
      height: 3px;
    }

    .education-mentor-content {
      gap: 1.5rem;
    }

    .education-card,
    .mentor-card {
      padding: 1rem;
      border-radius: 12px;
    }

    .card-header {
      margin-bottom: 1.5rem;
    }

    .card-title {
      font-size: 1.1rem;
    }

    .card-decoration {
      width: 35px;
      height: 35px;
      top: -5px;
      right: -5px;
    }

    .decoration-icon {
      font-size: 1rem;
    }

    .card-image-container {
      margin-bottom: 1rem;
      border-radius: 8px;
      border-width: 1px;
    }

    .overlay-content h4 {
      font-size: 1rem;
    }

    .overlay-content p {
      font-size: 0.8rem;
    }

    .detail-item {
      font-size: 0.75rem;
    }

    .card-description {
      font-size: 0.85rem;
      line-height: 1.5;
    }

    .achievements-stats {
      gap: 0.8rem;
      padding: 1rem;
      border-radius: 12px;
    }

    .stat-item {
      flex: 0 1 calc(50% - 0.4rem);
    }

    .stat-number {
      font-size: 1.3rem;
    }

    .stat-label {
      font-size: 0.75rem;
    }
  }

  /* 教育评估与创业导师模块样式 */
  .education-mentor-section {
    background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
    padding: 4rem 0;
    position: relative;
  }

  .education-mentor-section::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, #FF631E, transparent);
  }

  /* 横向布局容器 */
  .education-mentor-layout {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: 2rem;
    background: rgba(255, 255, 255, 0.95);
    padding: 3rem;
    border-radius: 20px;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.08);
    backdrop-filter: blur(15px);
    border: 1px solid rgba(255, 99, 30, 0.1);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    width: 100%;
    box-sizing: border-box;
  }

  .education-mentor-layout:hover {
    transform: translateY(-8px);
    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.12);
    border-color: rgba(255, 99, 30, 0.2);
  }

  /* 左侧区域 (60%宽度) */
  .left-section {
    flex: 0 0 60%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
  }

  /* 右侧区域 (40%宽度) */
  .right-section {
    flex: 0 0 40%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
  }

  /* 区域标题 */
  .section-subtitle {
    font-size: 1.5rem;
    font-weight: 700;
    color: #2c3e50;
    margin: 0 0 1.5rem 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: linear-gradient(120deg, #FF631E, #ff8c42);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }


  /* 图片容器 */
  .image-container {
    position: relative;
    flex: 1;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    border: 3px solid rgba(255, 99, 30, 0.2);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .image-container:hover {
    transform: scale(1.02);
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.15);
    border-color: rgba(255, 99, 30, 0.4);
  }

  .section-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s ease;
    min-height: 300px;
  }

  .image-container:hover .section-img {
    transform: scale(1.05);
  }

  /* 图片遮罩 */
  .image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255, 99, 30, 0.9), rgba(255, 140, 66, 0.9));
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    padding: 2rem;
  }

  .image-container:hover .image-overlay {
    opacity: 1;
  }

  .overlay-content {
    text-align: center;
  }

  .overlay-content h4 {
    font-size: 1.5rem;
    font-weight: 700;
    margin: 0 0 1rem 0;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }

  .overlay-content p {
    font-size: 1.1rem;
    margin: 0;
    line-height: 1.4;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  }

  /* 响应式设计 */
  @media (max-width: 992px) {
    .education-mentor-section {
      padding: 3rem 0;
    }

    .education-mentor-layout {
      gap: 1.5rem;
      padding: 2rem;
    }

    .section-subtitle {
      font-size: 1.3rem;
      margin-bottom: 1.2rem;
    }



    .section-img {
      min-height: 250px;
    }

    .overlay-content h4 {
      font-size: 1.3rem;
    }

    .overlay-content p {
      font-size: 1rem;
    }
  }

  @media (max-width: 600px) {
    .education-mentor-section {
      padding: 2.5rem 0;
    }

    .education-mentor-layout {
      flex-direction: column !important;
      gap: 2rem;
      padding: 1.5rem;
    }

    .left-section,
    .right-section {
      flex: none !important;
      width: 100% !important;
    }

    .section-subtitle {
      font-size: 1.2rem;
      margin-bottom: 1rem;
    }



    .image-container {
      border-radius: 12px;
      border-width: 2px;
    }

    .section-img {
      min-height: 200px;
    }

    .image-overlay {
      padding: 1.5rem;
    }

    .overlay-content h4 {
      font-size: 1.2rem;
    }

    .overlay-content p {
      font-size: 0.9rem;
    }
  }

  @media (max-width: 576px) {
    .education-mentor-section {
      padding: 2rem 0;
    }

    .education-mentor-layout {
      gap: 1.5rem;
      padding: 1rem;
      border-radius: 12px;
    }

    .education-mentor-layout:hover {
      transform: translateY(-3px);
    }

    .section-subtitle {
      font-size: 1.1rem;
      margin-bottom: 0.8rem;
      padding-bottom: 0.8rem;
    }



    .image-container {
      border-radius: 8px;
      border-width: 1px;
    }

    .image-container:hover {
      transform: scale(1.01);
    }

    .section-img {
      min-height: 160px;
    }

    .image-overlay {
      padding: 1rem;
    }

    .overlay-content h4 {
      font-size: 1rem;
      margin-bottom: 0.5rem;
    }

    .overlay-content p {
      font-size: 0.8rem;
      line-height: 1.3;
    }
  }
}
</style>